<script setup lang="ts">
import { useLowBalanceReminder } from '../model/useLowBalanceReminder'
import LowBalanceModal from './LowBalanceModal.vue'

const { visible, close } = useLowBalanceReminder()
</script>

<template>
  <LowBalanceModal v-if="visible" :model-value="visible" @close="close" />
</template>
